import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Router } from '@angular/router';

import { AslibLoadingService } from '@aslib/loading';
import { AslibAuthService } from '@aslib/security';
import { Observable } from 'rxjs/Observable';
import { Http, ResponseContentType, Headers, RequestOptions } from '@angular/http';

import { ExportTypes } from './../enum/TypeExportReportEnums';
import { UtilHelper } from '../helpers/util-helper';
import { BaseConfig } from './base-config.service';
import { ValidationService } from './ValidationService';
import { RelatorioModel } from '../model/relatorio.model';

@Injectable()
export class GenericHttpService<T> {
  private readonly application_pdf = 'application/pdf';
  private aslibLoadingContador = 0;
  public aslibLoadingConcluir = true;
  private readonly valueHeaders = 'application/json';
  private readonly contentType  = 'Content-Type'

  constructor(
    private readonly http: HttpClient,
    private readonly aslibAuthService: AslibAuthService,
    private readonly aslibLoadingService: AslibLoadingService,
    private readonly rotaService: Router,
    private baseConfig: BaseConfig,
    private readonly httpReport: Http
  ) {}


  public obterUrlRota(_controller: string, _router: string): string {
    return `${this.baseConfig.getBaseUrlApi()}/${_controller}/${_router}`;
  }

  public handleResponseBlob = (response: Response): Blob | Observable<Blob> => {
    this.aslibLoadingComplete();
    const fileBlob = response.blob();
    return new Blob([fileBlob]);
  };

  public handleResponse = (response: T[]) => {
    this.aslibLoadingComplete();
    return response;
  };

  public handleResponseT = (response: T) => {
    this.aslibLoadingComplete();
    return response;
  };

  public handleResponseTBlob = (response: any) => {
    this.aslibLoadingComplete();
    return new Blob([response.body]);
  };

  private aslibLoadingStart() {
    if (this.aslibLoadingContador === 0) {
      this.aslibLoadingService.start();
    }

    this.aslibLoadingContador += 1;
  }

  private aslibLoadingComplete() {
    this.aslibLoadingContador -= 1;
    if (this.aslibLoadingContador === 0) {
      this.aslibLoadingService.complete();
    }
  }

  public handleError = (error: HttpErrorResponse) => {
    this.aslibLoadingComplete();

    if (error.status === 401 || error.statusText === 'Token expirado') {
      this.logouf();
      return Observable.throw(this.mensagemViewModel(error.status, 'Tempo de sessão expirado.'));
    } else if (error.status === 520) {
      return Observable.throw(this.handlerErrorBusiness(error.error));
    } else if (error.status === 521) {
      const jsonMensagem = JSON.parse(error.statusText);
      return Observable.throw(this.mensagemViewModel(error.status, jsonMensagem.Mensagem, jsonMensagem.Tipo, jsonMensagem.Titulo));
    } else if (error.status === 500) {
      return Observable.throw(error.error);
    } else {
      return Observable.throw(this.mensagemViewModel(error.status, ValidationService.Messages.Generica.MSG_GENERICA_ERRO_INESPERADO_HTTP));
    }
  };

  private mensagemViewModel(_status: any, _mensagem: string, _tipo = 'error', _titulo = 'Erro') {
    return { status: _status, Mensagem: _mensagem, Tipo: _tipo, Titulo: _titulo };
  }

  private handlerErrorBusiness(_error: any) {
    let resultMensagemJson;
    if (_error instanceof Blob) {
      const fr = new FileReader();
      fr.readAsText(_error);
      setTimeout(() => {
        resultMensagemJson = JSON.parse(fr.result);
      }, 10000);
    } else {
      resultMensagemJson = _error;
    }

    return resultMensagemJson;
  }

  public post(url: string, obj: T): Observable<T> {
    return this.postAny(url, obj);
  }

  public postAny(url: string, obj: any): Observable<T> {
    return this.httpPostJson(url, obj);
  }

  public download(url: string, obj: T): Observable<T> {
    this.aslibLoadingStart();
    const header = this.getRequestOptionsContentTypeJsonBlob();
    const payLoad = JSON.stringify(obj);

    return this.http
      .post(url, payLoad, {
        headers: header,
        observe: 'response',
        responseType: 'blob'
      })
      .map(response => this.handleResponseTBlob(response))
      .catch(err => this.handleError(err));
  }

  private httpPostJson(url: string, obj: any) {
    this.aslibLoadingStart();
    const header = this.getRequestOptionsContentTypeJson();
    const payLoad = JSON.stringify(obj);

    return this.http
      .post<T>(url, payLoad, {
        headers: header,
        responseType: 'json'
      })
      .map(this.handleResponseT)
      .catch(this.handleError);
  }

  public postResponse(url: string, obj: T): Observable<Response> {
    return this.postAnyResponse(url, obj);
  }

  public postAnyResponse(url: string, obj: any): Observable<Response> {
    return this.httpPostJson(url, obj);
  }

  public getAny(url: string, params?: HttpParams): Observable<any> {
    const header = this.getHeaders();
    return this.httpGet(url, header, params);
  }

  public getBoolean(url: string): Observable<boolean> {
    const header = this.getHeaders();
    return this.httpGet(url, header);
  }

  public getById(url: string): Observable<T> {
    const header = this.getHeaders();
    return this.httpGet(url, header);
  }

  public getAll(url: string, params?: any): Observable<Array<T>> {
    const header = this.getHeaders();
    let payLoad = null;
    if (params !== null) {
      payLoad = JSON.stringify(params);
    }

    return this.httpGet(url, header , payLoad);
  }

  private httpGet(url: string, header: HttpHeaders, params?: HttpParams) {
    this.aslibLoadingStart();

    return this.http
      .get<Array<T>>(url, {
        headers: header,
        params: params,
        responseType: 'json'
      })
      .map(this.handleResponse)
      .catch(this.handleError);
  }

  public put(url: string, t: T): Observable<any> {
    this.aslibLoadingStart();
    const header = this.getRequestOptionsContentTypeJson();
    const payLoad = JSON.stringify(t);

    return this.http
      .put(url, payLoad, { headers: header })
      .map(this.handleResponse)
      .catch(this.handleError);
  }

  public putAny(url: string, t: any): Observable<any> {
    this.aslibLoadingStart();
    const header = this.getRequestOptionsContentTypeJson();
    const payLoad = t;

    return this.http
      .put(url, payLoad, { headers: header })
      .map(this.handleResponse)
      .catch(this.handleError);
  }

  public delete(url: string, id: any): Observable<string> {
    this.aslibLoadingStart();
    const header = this.getHeaders();

    if (!url.endsWith('/')) {
      url = url.concat('/');
    }

    return this.http
      .delete(url + id, { headers: header })
      .map(this.handleResponse)
      .catch(this.handleError);
  }

  public getApiKey() {
    return `${this.aslibAuthService.getAuthorizationToken()}`;
  }

  protected getHeaders(): HttpHeaders {
    return new HttpHeaders().set('Authorization', `Bearer ${this.getApiKey()}`);
  }

  protected getRequestOptionsContentTypeJson(): HttpHeaders {
    return this.getHeaders().set('Content-type', this.valueHeaders);
  }

  protected getRequestOptionsContentTypeJsonBlob(): HttpHeaders {
    return this.getRequestOptionsContentTypeJson().set('ResponseContentType', 'Blob');
  }

  public deleteCompositeKey(url: string, ids: Array<string>): Observable<string> {
    this.aslibLoadingStart();
    const header = this.getHeaders();

    if (ids !== null && ids.length > 0) {
      ids.forEach(id => {
        url = url.concat('/').concat(id);
      });
    }

    return this.http
      .delete(url, { headers: header })
      .map(this.handleResponse)
      .catch(this.handleError);
  }

  public deleteCompositebase64(url: string, ids: Array<[string, any]>): Observable<string> {
    const parametroBase64: string = UtilHelper.obterParametrosBase64(ids);
    return this.delete(url, parametroBase64);
  }

  public getByIdCompositebase64(url: string, ids: Array<[string, any]>): Observable<T> {
    const parametroBase64: string = UtilHelper.obterParametrosBase64(ids);

    if (!url.endsWith('/')) {
      url = url.concat('/');
    }

    if (parametroBase64 !== '') {
      url += parametroBase64;
    }

    return this.getById(url);
  }

  private logouf() {
    this.aslibAuthService.logout();

    this.rotaService.navigate(['/']);
    this.aslibLoadingComplete();
  }

  public report(url: string, obj: any, exportType?: ExportTypes): Observable<Blob> {

    let applicationType: string;
    const myHeaders = new Headers();
    myHeaders.append(this.contentType, this.valueHeaders);
    myHeaders.append('Authorization', `Bearer ${this.getApiKey()}`);
    const options = new RequestOptions({ headers: myHeaders, responseType: ResponseContentType.Blob });

    let relatorioModel = new RelatorioModel();
    relatorioModel.Entidade = obj;

    relatorioModel.TipoRelatorio = exportType === undefined ? ExportTypes.PDF : exportType;

    applicationType = exportType === ExportTypes.Excel_xls ? 'application/vnd.ms-excel' : this.application_pdf;

    return this.httpReport.post(url, relatorioModel, options).map(res => {
        return new Blob([res.blob()], { type: applicationType });
    });

  }

   public reportIpva(url: string, obj: any): Observable<Blob> {

    let applicationType: string;
    const myHeaders = new Headers();
    myHeaders.append(this.contentType, this.valueHeaders);
    myHeaders.append('Authorization', `Bearer ${this.getApiKey()}`);
    const options = new RequestOptions({ headers: myHeaders, responseType: ResponseContentType.Blob });

    applicationType ='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

    return this.httpReport.get(url, options).map(res => {
        return new Blob([res.blob()], { type: applicationType });
    });

  }

  public reportExcel(url: string, obj: any[]): Observable<Blob> {

    let applicationType: string;
    const myHeaders = new Headers();
    myHeaders.append(this.contentType, this.valueHeaders);
    myHeaders.append('Authorization', `Bearer ${this.getApiKey()}`);
    const options = new RequestOptions({ headers: myHeaders, responseType: ResponseContentType.Blob });

    applicationType ='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

    return this.httpReport.post(url, obj, options).map(res => {
        return new Blob([res.blob()], { type: applicationType });
    });

  }

  UploadArquivo(url: string, formData: FormData) {
    const headers = new HttpHeaders();
    headers.append(this.contentType, 'multipart/form-data');
    headers.append('Accept', this.valueHeaders);
    const httpOptions = { headers: headers };

    return this.http.post(url, formData, httpOptions)
  }

  UmloadArquivos(url: string, formData: FormData){
  const headers = new Headers();
  headers.append(this.contentType, 'multipart/form-data');
  headers.append('Accept', 'application/json');
  const httpOptions = new RequestOptions({ headers: headers });

  return this.httpReport.post(url, formData, httpOptions);

}
  public DownloadTxt(url: string, obj: any){

    return this.http.post(url, obj, {
      responseType: 'blob'
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/service/generic-http.service.ts